import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Sparkles, X, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-whats-new`;

export const WhatsNewPanel = ({ token, onTab }) => {
  const [d, setD] = useState(null);
  const h = { headers: { Authorization: `Bearer ${token}` } };
  useEffect(() => { axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setD(r.data)).catch(() => {}); }, [token]);
  if (!d || d.dismissed) return null;
  const dismiss = () => { setD({ ...d, dismissed: true }); axios.post(`${API}/me/dismiss`, {}, h).catch(() => {}); };
  const go = (i) => {
    if (!i.tab) { window.location.href = i.link; return; }
    onTab(i.tab);
    setTimeout(() => document.querySelector(`[data-testid="pas-tab-${i.tab}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
  };
  return (
    <div className="mb-6 bg-gradient-to-br from-emerald-900/40 to-slate-900 border border-emerald-700/40 rounded-xl p-5" data-testid="whats-new-panel">
      <div className="flex items-start justify-between gap-4 mb-3">
        <div>
          <p className="text-white font-bold flex items-center gap-2"><Sparkles className="w-4 h-4 text-emerald-400" /> What's new</p>
          <p className="text-xs text-emerald-300" data-testid="whats-new-tier">{d.tier_label}</p>
        </div>
        <button onClick={dismiss} className="text-slate-400 hover:text-white" data-testid="whats-new-dismiss"><X className="w-4 h-4" /></button>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {d.items.map(i => (
          <button key={i.id} onClick={() => go(i)} className="text-left bg-slate-900/70 hover:bg-slate-800 border border-slate-700 rounded-lg p-3 transition-colors group" data-testid={`whats-new-item-${i.id}`}>
            <p className="text-sm text-white font-semibold flex items-center justify-between">{i.title}<ChevronRight className="w-4 h-4 text-slate-500 group-hover:text-emerald-400 transition-transform group-hover:translate-x-0.5" /></p>
            <p className="text-[11px] text-slate-400 mt-1">{i.body}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
